module.exports = __webpack_public_path__ + "assets/img/00010.21463da6.png";